export default __webpack_public_path__ + "static/media/2.e8cf1e03.jpg";